module.exports = function daysAgo() {
  return function daysAgoFilter(dateString) {
    const currentDate = new Date();
    const date = new Date(dateString);
    const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const timeDiff = currentDate.getTime() - startOfDate.getTime();
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    if (days === 0) {
      return 'today';
    }

    if (days === 1) {
      return '1 day ago';
    }

    if (days > 1) {
      return `${days} days ago`;
    }

    return '';
  };
};
